// extracted by mini-css-extract-plugin
module.exports = {"progress":"Scans_progress__2sELG"};